import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';
import { trackProductEvent } from '@/lib/product-analytics';

export default function ProductAnalyticsTracker() {
  const location = useLocation();
  const { user } = useApp();

  useEffect(() => {
    if (!user) return;

    void trackProductEvent({
      userId: user.id,
      eventName: 'page_view',
      path: location.pathname,
      metadata: {
        search: location.search || null,
      },
    });
  }, [location.pathname, location.search, user]);

  return null;
}
